// extracted by mini-css-extract-plugin
module.exports = {"location__data":"Location-hashed__location__data__1ss6Z","location__dataLabel":"Location-hashed__location__dataLabel__ut8ii"};